/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import Applications from '../applications/container/ApplicationContainer';
import TransactionsContainer from '../dashboard/TransactionsContainer';
import OhpSettingsContainer from '../settings/OhpSettingsContainer';

function OHPContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Occupational and Health</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW OHP DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/occupational-and-health"
          >
            Dashboard
          </NavLink>
        )}
        {(Acl(permissions, ['VIEW OHP NEW TRANSACTIONS']) ||
          Acl(permissions, ['VIEW OHP EDUC TRANSACTIONS'])) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/occupational-and-health/application"
          >
            Applications
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OHP SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/occupational-and-health/settings"
          >
            Settings
          </NavLink>
        )}
      </div>
      <Switch>
        {Acl(permissions, ['VIEW OHP DASHBOARD']) && (
          <Route
            exact
            path={`${match.path}`}
            component={TransactionsContainer}
          />
        )}
        {(Acl(permissions, ['VIEW OHP NEW TRANSACTIONS']) ||
          Acl(permissions, ['VIEW OHP EDUC TRANSACTIONS'])) && (
          <Route path={`${match.path}/application`} component={Applications} />
        )}
        {Acl(permissions, ['VIEW OHP SETTINGS']) && (
          <Route
            path={`${match.path}/settings`}
            component={OhpSettingsContainer}
          />
        )}
      </Switch>
    </div>
  );
}

OHPContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(OHPContainer);
